import { useState, useEffect } from "react";
import _ from "lodash";

export async function fetchUrl(path, onLoad, onError) {
  try {
    const response = await fetch(path + `?ts=${new Date().getTime()}`, {
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const json = await response.json();

    onLoad(json);
  } catch (e) {
    console.log(e);
    onError(e);
  }
}

export const useLoad = (url, fetch = true) => {
  const [currState, setCurrState] = useState({
    data: null,
    loading: false,
    error: false,
    status: fetch ? "fetch" : "idle",
  });
  const { status } = currState;

  useEffect(() => {
    if (status === "fetch") {
      setCurrState((state) => ({
        ...state,
        loading: true,
        status: "fetching",
      }));
      fetchUrl(
        url,
        (data) => {
          setCurrState((state) => ({
            ...state,
            loading: false,
            error: null,
            data,
            status: "idle",
          }));
        },
        (e) =>
          setCurrState((state) => ({
            ...state,
            loading: false,
            error: e,
            data: null,
            status: "idle",
          }))
      );
    }
  }, [status]);

  return currState;
};
